import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

export default {
  mixins: [dashboardPartnerData],
  computed: {
    currentMutation() {
      return this.partnerData?.mutations
        ? (this.partnerData.mutations.find(item => item.language === this.$auth.user?.language) ??
            {})
        : {};
    },
    hasCovidLink() {
      if (this.currentMutation && this.currentMutation.webLayoutItems) {
        return (
          this.currentMutation.webLayoutItems.findIndex(
            item => item.segmentKey === 'covid_linka_box'
          ) > -1
        );
      }

      return false;
    },
    hasWebchat() {
      if (!this.$auth?.user?.benefit?.active) {
        return false;
      }

      const { showWebChat } = this.currentMutation ?? {};
      const hasValidHost = this.$auth.user.invitation?.host !== null;

      if (hasValidHost) {
        return showWebChat === 'CoreAndFamily';
      }

      return showWebChat?.includes('Core');
    },
    hasAssistLink() {
      if (this.currentMutation && this.currentMutation.webLayoutItems) {
        return (
          this.currentMutation.webLayoutItems.findIndex(
            item => item.segmentKey === 'asistencni_linka_box'
          ) > -1
        );
      }

      return false;
    },
    assistLine() {
      if (this.hasAssistLink) {
        return JSON.parse(
          this.currentMutation.webLayoutItems.find(
            item => item.segmentKey === 'asistencni_linka_box'
          ).webTextContents[0].textContent
        );
      }

      return null;
    },
    covidLine() {
      if (this.hasCovidLink) {
        return JSON.parse(
          this.currentMutation.webLayoutItems.find(item => item.segmentKey === 'covid_linka_box')
            .webTextContents[0].textContent
        );
      }

      return null;
    },
    priceNotFullyCovered() {
      return this.currentMutation?.discountValue < 100 && this.currentMutation?.questionPrice > 0;
    },
    pricePartlyCovered() {
      return this.currentMutation?.discountValue > 0 && this.priceNotFullyCovered;
    }
  }
};
